<template>
  <div class="course-trainer-rela">
    <div class="pkg-search-box">
      <el-form class="pkg-content"
               :inline="false"
               :model="dataForm"
               ref="vehicleInfoRef"
               @keyup.enter.native="queryCourse()"
               label-width="auto">
        <!--查询条件 第一行-->
        <el-row class="margb10 trainer-search-condition">
          <!-- 第一行 -->
          <!-- 车辆底盘号 -->
          <el-col :span="7">
            <el-form-item :label="$t('vehicleAllocation.vehicleNo')">
              <el-input v-model="dataForm.vehicleNo"
                        :placeholder="$t('vehicleAllocation.vehicleNo')"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 运输开始时间起 -->
          <el-col :span="7">
            <el-form-item :label="$t('vehicleAllocation.transportDateS1')">
              <el-date-picker v-model="dataForm.transportDateS1"
                              type="date"
                              value-format="yyyy-MM-dd"
                              :placeholder="$t('vehicleAllocation.transportDateS1')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 运输开始时间止 -->
          <el-col :span="7">
            <el-form-item :label="$t('vehicleAllocation.transportDateS2')">
              <el-date-picker v-model="dataForm.transportDateS2"
                              type="date"
                              value-format="yyyy-MM-dd"
                              :placeholder="$t('vehicleAllocation.transportDateS2')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="3"
                  class="query-button">
            <!-- 查询按钮 -->
            <el-col :span="24">
              <!--v-if="$hasPermission('AUTHCOURSE0001')"-->
              <!--查询按钮-->
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         type="primary"
                         :loading = "dataListLoading"
                         @click="queryCourse">{{ $t('query') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <!--查询条件 第二行-->
        <el-row class="margb10 trainer-search-condition">
          <!-- 调配单号 -->
            <el-col :span="7">
              <el-form-item :label="$t('vehicleAllocation.deploymentNo')">
                <el-input v-model="dataForm.deploymentNo"
                          :placeholder="$t('vehicleAllocation.deploymentNo')"
                          clearable></el-input>
              </el-form-item>
            </el-col>
          <!-- 运输结束时间起 -->
          <el-col :span="7">
            <el-form-item :label="$t('vehicleAllocation.transportDateE1')">
              <el-date-picker v-model="dataForm.transportDateE1"
                              type="date"
                              value-format="yyyy-MM-dd"
                              :placeholder="$t('vehicleAllocation.transportDateE1')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 运输结束时间止 -->
          <el-col :span="7">
            <el-form-item :label="$t('vehicleAllocation.transportDateE2')">
              <el-date-picker v-model="dataForm.transportDateE2"
                              type="date"
                              value-format="yyyy-MM-dd"
                              :placeholder="$t('vehicleAllocation.transportDateE2')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 重置按钮 -->
          <el-col :span="3"
                  class="query-button">
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         v-if="$hasPermission('AUTHCOURSE0002')"
                         :loading = "dataListLoading"
                         @click="resetQuery()">{{ $t('reset') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <!--查询条件 第三行-->
        <div v-show="moreList">
          <el-row class="margb10 trainer-search-condition">
            <!-- 调配单状态 -->
          <el-col :span="7">
            <el-form-item :label="$t('vehicleAllocation.status')">
              <el-select multiple
                         collapse-tags
                         v-model="dataForm.statusList">
                <el-option v-for="(item,index) in deploymentStatus"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

            <!-- 通知时间起 -->
            <el-col :span="7">
              <el-form-item :label="$t('vehicleAllocation.noticeTimeS')">
                <el-date-picker v-model="dataForm.noticeTime1"
                                type="date"
                                value-format="yyyy-MM-dd"
                                :placeholder="$t('vehicleAllocation.noticeTimeS')">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!-- 通知时间止 -->
            <el-col :span="7">
              <el-form-item :label="$t('vehicleAllocation.noticeTimeE')">
                <el-date-picker v-model="dataForm.noticeTime2"
                                type="date"
                                @change="dataUpdate"
                                value-format="yyyy-MM-dd"
                                :placeholder="$t('vehicleAllocation.noticeTimeE')">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="margb10 trainer-search-condition">
            <!-- 目的地 -->
            <el-col :span="7">
              <el-form-item :label="$t('vehicleAllocation.destinationPlace')">
                <el-input v-model="dataForm.destinationPlace"
                          :placeholder="$t('vehicleAllocation.destinationPlace')"
                          clearable></el-input>
              </el-form-item>
            </el-col>
            <!-- 始发地 -->
            <el-col :span="7">
              <el-form-item :label="$t('vehicleAllocation.originalPlace')">
                <el-input v-model="dataForm.originalPlace"
                          :placeholder="$t('vehicleAllocation.originalPlace')"
                          clearable></el-input>
              </el-form-item>
            </el-col>
            <!-- 申请人 -->
            <el-col :span="7">
              <el-form-item :label="$t('vehicleAllocation.applicantName')">
                <el-input v-model="dataForm.applicantName"
                          :placeholder="$t('vehicleAllocation.applicantName')"
                          clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="margb10 trainer-search-condition">
            <!-- 调配原因 -->
            <el-col :span="7">
              <el-form-item :label="$t('vehicleAllocation.deploymentReason')">
                <el-select multiple
                           collapse-tags
                           v-model="dataForm.deploymentReasonList">
                  <el-option v-for="(item,index) in allocationReasonsList"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <!-- 展开or收起 -->
      <el-row style="text-align: center; margin-bottom: 10px;">
        <el-col :span="24">
          <div class="show-or-hide-icon"
               v-bind:class="{ 'el-icon-arrow-up': moreList,
                                       'el-icon-arrow-down': !moreList }"
               @click="moreList = !moreList">&nbsp;{{ moreList ? '收起' : '高级搜索' }}
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="pkg-content">
      <!-- 按钮 -->
      <div class="search">
        <!--创建调配单-->
        <el-button type="primary"
                   v-if="$hasPermission('AUTHCOURSE0003')"
                   :loading = "dataListLoading"
                   @click="addUpdate()">{{ $t('vehicleAllocation.add') }}</el-button>
        <!--导出-->
        <el-button type="primary"
                   v-if="$hasPermission('AUTHCOURSE0006')"
                   :loading = "dataListLoading"
                   @click="columnBtn()">{{ $t('res.rela.export') }}</el-button>
        <!--通知-->
        <el-button type="primary"
                   v-if="$hasPermission('AUTHCOURSE0005')"
                   :loading = "dataListLoading"
                   @click="notice">{{ $t('vehicleAllocation.notice') }}</el-button>
        <!--入库-->
        <el-button type="primary"
                   v-if="$hasPermission('AUTHCOURSE0004')"
                   :loading = "dataListLoading"
                   @click="storage">{{ $t('vehicleAllocation.warehousing') }}</el-button>
        <!--批量调配模板导出-->
        <el-button type="primary"
                   v-if="$hasPermission('AUTHCOURSE0007')"
                   :loading = "dataListLoading"
                   @click="exportVehicleAllocation">{{ $t('vehicleAllocation.batchExport') }}</el-button>
        <!--批量调配导入-->
        <el-button type="primary"
                   v-if="$hasPermission('AUTHCOURSE0007')"
                   :loading = "dataListLoading"
                   @click="vehicleAllImport">{{ $t('vehicleAllocation.batchImport') }}</el-button>
        <!--批量撤回-->
        <el-button type="primary"
                   v-if="$hasPermission('AUTHCOURSE0007')"
                   :loading = "dataListLoading"
                   @click="batchRevoke">{{ $t('vehicleAllocation.batchRevoke') }}</el-button>
      </div>

      <el-table :data="dataList"
                border
                stripe
                ref="vehicleAllocation"
                v-loading="dataListLoading"
                @selection-change="selectionChangeHandle"
                style="width: 100%;"
                :row-class-name="tableRowClassName">
        <el-table-column type="selection"
                         header-align="center"
                         align="center"
                         width="50">
        </el-table-column>
        <!-- 调配单号 -->
        <el-table-column class="link-type"
                         prop="deploymentNo"
                         header-align="center"
                         align="center"
                         width="160"
                         :label="$t('vehicleAllocation.deploymentNo')">
        </el-table-column>
        <!-- 调配原因 -->
        <el-table-column prop="deploymentReason"
                         header-align="center"
                         align="center"
                         :formatter="deploymentReason"
                         show-overflow-tooltip
                         width="150"
                         :label="$t('vehicleAllocation.deploymentReason')">
        </el-table-column>
        <!-- 车辆底盘号 -->
        <el-table-column prop="vehicleNo"
                         header-align="center"
                         align="center"
                         :width="100"
                         show-overflow-tooltip
                         :label="$t('vehicleAllocation.vehicleNo')">
          <template slot-scope="scope">
            <!--查看-->
            <span class="el-dropdown-link"
                  @click="checkVehicleNo(scope.row)">{{ scope.row.vehicleNo }}</span>
          </template>
        </el-table-column>
        <!-- 课程编号 -->
        <el-table-column header-align="center"
                         align="center"
                         :label="$t('vehicleAllocation.courseCode')">
          <template slot-scope="scope">
            <!--查看-->
            <span class="el-dropdown-link"
                  v-if="scope.row.deploymentReason === '10' && scope.row.deploymentReason !== '30' && scope.row.status !== '40'"
                  @click="checkDeploymentReason(scope.row)">{{ $t('res.vehinfo.check') }}</span>
          </template>
        </el-table-column>
        <!-- 课程编号 -->
        <!--<el-table-column prop="teamcName"-->
                         <!--header-align="center"-->
                         <!--align="center"-->
                         <!--show-overflow-tooltip-->
                         <!--width="150"-->
                         <!--:label="$t('vehicleAllocation.courseCode')">-->
        <!--</el-table-column>-->
        <!-- 始发地 -->
        <el-table-column prop="originalPlace"
                         header-align="center"
                         align="center"
                         :width="140"
                         show-overflow-tooltip
                         :label="$t('vehicleAllocation.originalPlace')">
        </el-table-column>
        <!-- 目的地 -->
        <el-table-column prop="destinationPlace"
                         header-align="center"
                         align="center"
                         width="150"
                         show-overflow-tooltip
                         :label="$t('vehicleAllocation.destinationPlace')">
        </el-table-column>
        <!-- 运输开始时间 -->
        <el-table-column prop="transportDateS"
                         header-align="center"
                         align="center"
                         width="150"
                         :formatter="transportDateSFormatter"
                         show-overflow-tooltip
                         :label="$t('vehicleAllocation.transportDateS')">
        </el-table-column>
        <!-- 运输结束时间 -->
        <el-table-column prop="transportDateE"
                         header-align="center"
                         align="center"
                         width="150"
                         :formatter="transportDateEFormatter"
                         show-overflow-tooltip
                         :label="$t('vehicleAllocation.transportDateE')">
        </el-table-column>
        <!-- 申请人 -->
        <el-table-column prop="applicantName"
                         header-align="center"
                         align="center"
                         width="150"
                         show-overflow-tooltip
                         :label="$t('vehicleAllocation.applicantName')">
        </el-table-column>
        <!-- 申请时间 -->
        <el-table-column prop="applyTime"
                         header-align="center"
                         align="center"
                         width="150"
                         show-overflow-tooltip
                         :label="$t('vehicleAllocation.applyTime')">
        </el-table-column>
        <!-- 通知时间 -->
        <el-table-column prop="noticeTime"
                         header-align="center"
                         align="center"
                         width="150"
                         show-overflow-tooltip
                         :label="$t('vehicleAllocation.noticeTime')">
        </el-table-column>
        <!-- 调配单状态 -->
        <el-table-column prop="status"
                         :formatter="statusFormatter"
                         header-align="center"
                         align="center"
                         width="120"
                         :label="$t('vehicleAllocation.status')">
        </el-table-column>
        <!-- 冲突的排期编号 -->
        <el-table-column prop="conflictOfferingNos"
                         header-align="center"
                         align="center"
                         :formatter="offeringNosformat"
                         :width="140"
                         show-overflow-tooltip
                         :label="$t('vehicleAllocation.conflictOfferingNos')">
        </el-table-column>
        <!--操作-->
        <el-table-column fixed="right"
                         align="center"
                         width="120"
                         :label="$t('handle')">
          <template slot-scope="scope">
            <!--查看-->
            <span class="el-dropdown-link"
                  @click="Update(scope.row, 'query')">{{ $t('view') }}</span>
              <div class="pkg-vertical-divider"></div>
              <el-dropdown trigger="click"
                           placement="bottom">
                  <span class="el-dropdown-link">
                    {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
                  </span>
                   <el-dropdown-menu slot="dropdown">
                       <!--编辑-->
                       <el-dropdown-item v-if="scope.row.status !== '40'" @click.native="Update(scope.row, 'update')">{{ $t('vehicleAllocation.update') }}</el-dropdown-item>
                       <!--撤销-->
                       <el-dropdown-item v-if="scope.row.status === '20'" @click.native="revoke(scope.row)">{{ $t('vehicleAllocation.delete') }}</el-dropdown-item>
                       <!--撤回-->
                       <el-dropdown-item v-if="scope.row.status === '30'" @click.native="recall(scope.row)">{{ $t('vehicleAllocation.recall') }}</el-dropdown-item>
                       <!--归还申请-->
                       <el-dropdown-item v-if="scope.row.canReturn === '1'" @click.native="returnAdd(scope.row)">{{ $t('vehicleAllocation.returnAdd') }}</el-dropdown-item>
                   </el-dropdown-menu>
              </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle"
                     :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
      <!--车辆信息-->
      <el-dialog title="车辆信息"
                 :visible="isShowVehicle"
                 width="70%"
                 :before-close="showVehicleClose">
            <el-main style="color: #333; text-align: center; line-height: 100%;">
              <el-row>
                <el-col>
                  <el-table :data="vehicleInfoList"
                            border
                            style="width: 100%;">
                    <!-- 车辆ID -->
                    <el-table-column prop="id"
                                     header-align="center"
                                     align="center"
                                     v-if="false"
                                     width="100"
                                     :label="$t('handle')">
                    </el-table-column>
                    <!-- 车辆底盘号 -->
                    <el-table-column prop="chassisNo"
                                     header-align="center"
                                     align="center"
                                     width="100"
                                     show-overflow-tooltip
                                     :label="$t('res.vehinfo.chassisNo')">
                    </el-table-column>
                    <!-- 车型分类 -->
                    <el-table-column prop="classCnName"
                                     header-align="center"
                                     align="center"
                                     show-overflow-tooltip
                                     :label="$t('res.vehinfo.vehicleClassId')">
                    </el-table-column>
                    <!-- 所属公司 -->
                    <el-table-column prop="companyCnName"
                                     header-align="center"
                                     align="center"
                                     show-overflow-tooltip
                                     :label="$t('res.vehinfo.companyId')">
                    </el-table-column>
                    <!-- 所属场地 -->
                    <el-table-column prop="siteCnName"
                                     header-align="center"
                                     align="center"
                                     show-overflow-tooltip
                                     :label="$t('res.vehinfo.subordinateSiteId')">
                    </el-table-column>
                    <!-- 当前场地 -->
                    <el-table-column prop="presentSiteName"
                                     header-align="center"
                                     align="center"
                                     show-overflow-tooltip
                                     :label="$t('res.vehinfo.presentSiteId')">
                    </el-table-column>
                    <!-- 车辆分类 -->
                    <el-table-column prop="vehicleClassification"
                                     :formatter="vehicleClassFormatter"
                                     header-align="center"
                                     align="center"
                                     show-overflow-tooltip
                                     :label="$t('res.vehinfo.vehicleClassification')">
                    </el-table-column>
                    <!-- 车辆标签 -->
                    <el-table-column prop="classroomLabel"
                                     header-align="center"
                                     align="center"
                                     :label="$t('res.vehinfo.label')">
                      <template slot-scope="scope">
                        <!--查看-->
                        <span class="el-dropdown-link"
                              v-if="scope.row.number !== null"
                              @click="checkLable(scope.row)">{{ $t('res.vehinfo.check') }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </el-main>
      </el-dialog>

      <!--排期信息-->
      <el-dialog title="排期信息"
                 :visible="isShowDeploymentReason"
                 width="70%"
                 :before-close="showDeploymentReasonClose">
        <el-main style="color: #333; text-align: center; line-height: 100%;">
          <el-row>
            <el-col>
              <el-table :data="courseList"
                        border
                        style="width: 100%;">
                <el-table-column prop="courseNo"
                                 header-align="center"
                                 type="index"
                                 align="center"
                                 :label="$t('res.rela.label')">
                </el-table-column>
                <!-- 排期编号 -->
                <el-table-column prop="offeringNo"
                                 header-align="center"
                                 align="center"
                                 width="100"
                                 show-overflow-tooltip
                                 :label="$t('vehicleAllocation.offeringNo')">
                </el-table-column>
                <!-- 课程编号 -->
                <el-table-column prop="courseCode"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('vehicleAllocation.courseCode')">
                </el-table-column>
                <!-- 课程名称 -->
                <el-table-column prop="courseNameCn"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('vehicleAllocation.courseNameCn')">
                </el-table-column>
                <!-- 课程分类 -->
                <!--<el-table-column prop="courseCatalogName"-->
                                 <!--header-align="center"-->
                                 <!--align="center"-->
                                 <!--show-overflow-tooltip-->
                                 <!--:label="$t('vehicleAllocation.courseCatalogName')">-->
                <!--</el-table-column>-->
                <!-- 开始时间 -->
                <el-table-column prop="offeringDateS"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('vehicleAllocation.offeringDateS')">
                </el-table-column>
                <!-- 结束时间 -->
                <el-table-column prop="offeringDateE"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('vehicleAllocation.offeringDateE')">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-main>
      </el-dialog>

      <!--车辆调配导入-->
      <import-excel v-bind:visible="importDialog"
                    v-bind:url="importUrl"
                    v-on:closeDialogImport="closeDialogImport"></import-excel>

    </div>
  </div>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
import ClassTree from '@/components/rm/class-tree/index'
import importExcel from '@/components/rm/import-excel/index'
import selCertCourse from '@/components/rm/course-rela-multiple/index'
import Vue from 'vue'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        // getDataListURL: '/rm/vehicleinfoDeployment/list',
        // getDataListIsPage: true
      },
      dataForm: {
        statusList: [],
        deploymentReasonList: [],
        deploymentNo: '',
        originalPlace: '',
        destinationPlace: '',
        applicantName: '',
        noticeTime: '',
        noticeTime1: '',
        noticeTime2: '',
        vehicleNo: '',
        transportDateS: '',
        transportDateS1: '',
        transportDateS2: '',
        transportDateE: '',
        transportDateE1: '',
        transportDateE2: ''
      },
      // 导入车辆调配
      importDialog: false,
      // 导入车辆调配接口路径
      importUrl: '/rm/vehicleinfoDeployment/import',
      vehicleInfoList:[],
      courseList:[],
      isShowVehicle: false,
      isShowDeploymentReason: false,
      // 课程团队分类数据 End
      courseSelect: false,
      courseShowFlg: false,
      courseInfoList: [],
      moreform: false,
      moreList: false,
      deleteList: false,
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      // 课程状态
      newcoursestatus: this.enums['courseStatus'],
      // 调配单状态
      deploymentStatus: this.enums['deploymentStatus'],
      // 调配原因
      allocationReasonsList: this.enums['allocationReasons'],
      startDay1:'',
      startDay2:''
    }
  },
  components: {
    selCertCourse,
    'class-tree': ClassTree,
    'import-excel': importExcel
  },
  created () {
    console.log('created')
  },
  mounted () {
    let coursestatusB = []
    if (this.newcoursestatus && this.newcoursestatus.length > 0) {
      for (var i = 0; i < this.newcoursestatus.length; i++) {
        if (this.newcoursestatus[i].name !== '未发布') {
          coursestatusB.push(this.newcoursestatus[i])
        }
      }
      this.newcoursestatus = coursestatusB
    }
    this.courseShowFlg = false
    var TimeNow = new Date();
    // 当前月1号
    var startDay1 = new Date(TimeNow.getFullYear(), TimeNow.getMonth(), 1);
    console.info('当前月1号-------------->',startDay1)
    // 次月月底
    var monthDate = TimeNow.setMonth(TimeNow.getMonth() +2);
    var monthDate1 = new Date(new Date(monthDate).getFullYear(), new Date(monthDate).getMonth(), 1);
    var startDay2 = new Date(new Date(monthDate1) - 1 * 24 * 3600 * 1000)
    this.startDay1 = this.dateFormat("YYYY-mm-dd",startDay1)
    this.startDay2 = this.dateFormat("YYYY-mm-dd",startDay2)
    this.dataForm.transportDateS1 = this.dateFormat("YYYY-mm-dd",startDay1)
    this.dataForm.transportDateS2 = this.dateFormat("YYYY-mm-dd",startDay2)
    this.queryCourse()
  },
  methods: {
    getDataList() {
      let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
      if ('regionIds' in newDataForm) {
        if (newDataForm.regionIds.length === 0) {
          newDataForm.regionIds = ''
        } else {
          newDataForm.regionIds = newDataForm.regionIds.join(',')
        }
      }
      this.dataListLoading = true
      this.$request.get(
        '/rm/vehicleinfoDeployment/list',
        {
          order: this.order,
          orderField: this.orderField,
          page: this.page,
          limit: this.limit,
          ...newDataForm
        }
      ).then((res, total, code, data) => {
        this.dataListLoading = false
        let resultList = data.data.records
        this.dataList = resultList
        this.total = data.data.total
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 冲突：10，不冲突：20
    tableRowClassName(row) {
      if (row.row.isConflict === '10') {
        return 'warning-row';
      }
      return '';
    },
    gotoView (type, id) {
      let query = {}
      let name = 'rm-coursevehiclerela-add-or-update'
      query.courseVehicleRelaId = id
      if (type === 'view') {
        name = 'rm-coursevehiclerela-view'
        this.$router.push({
          name: name,
          query: query
        })
      } else if (type === 'update') {
        this.$router.push({
          name: name,
          query: query
        })
      } else if (type === 'delete') {
        this.deleteHandle(id)
      }
    },
    vehicleDelete (row) {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        let _this = this
        let courseId = row.courseId
        let stationId = row.stationId
        let url = ''
        let param = ''
        url = '/rm/coursevehiclerela/vehicleDelete'
        param = {
          'id': row.id,
          'courseId': courseId,
          'stationId': stationId
        }
        _this.$request.post(
          url, param
        ).then((data) => {
          _this.$message({
            message: _this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.getDataList()
            }
          })
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    addUpdate (row) {
      let name = 'rm-vehicleAllocation-add-or-update'
      let pkName = (row != null) ? row.courseVehicleRelaId : undefined
      let query = {}
      query.courseVehicleRelaId = pkName
      this.$router.push({
        name: name,
        query: query
      })
    },
    Update (row, type) {
      console.info('row传到页面的值-------------------->', row)
      let name = 'rm-vehicleAllocation-update'
      let query = {}
      query.id = row.id
      query.type = type
      query.states = row.status
      this.$router.push({
        name: name,
        query: query
      })
      // 广播通知执行初始化方法
      this.$eventHub.$emit(this.GLOBAL.COURSE_VEHICALERELA, '')
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 导入模板导出
    exportVehicleAllocation () {
      // download 参数 url, params, 报表名
      this.$request.download('/rm/file/downtemplate', this.$t('vehicleAllocation.ATTemplateExport'), {fileName: 'batch_deployment_template.xls'})
    },
    vehicleAllImport(){
      this.importDialog = true
    },
    // 关闭导入弹框
    closeDialogImport () {
      this.importDialog = false
    },
    // 批量删除
    BatchDeletion () {
      let _this = this
      let selectList = this.$refs.selectVehicleinfo.selection
      if (selectList.length <= 0) {
        this.$message.warning(this.$t('res.rela.selectDelete'))
        return false
      }
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        let url = ''
        // let param = ''
        url = '/rm/coursevehiclerela/deleteList'
        // param = { 'idList': idList }
        _this.$request.post(
          url, selectList
        ).then((data) => {
          _this.$message({
            message: _this.$t('prompt.success'),
            type: 'success',
            duration: 500
          })
          _this.getDataList()
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 批量导出
    exportHandle () {
      // download 参数 url, params, 报表名
      this.$request.download('/rm/coursevehiclerela/export', this.$t('res.rela.coursevehiclerela'),
        {
          ...this.dataForm,
          page: this.page,
          limit: this.limit
        }
      )
    },
    // 状态转换
    deploymentReason (row) {
      return Vue.filter('coverEnum')(row.deploymentReason, 'allocationReasons')
    },
    // 状态转换
    statusFormatter (row) {
      return Vue.filter('coverEnum')(row.status, 'deploymentStatus')
    },
    transportDateSFormatter(row){
      return this.dateFormat("YYYY-mm-dd",new Date(row.transportDateS.replace(/-/g, '/')))
   },
    transportDateEFormatter(row){
      return this.dateFormat("YYYY-mm-dd",new Date(row.transportDateE.replace(/-/g, '/')))
    },
    offeringNosformat (row){
      var offeringNos = row.conflictOfferingNos
      var conflictOfferingNos =''
      if (offeringNos){
        conflictOfferingNos = offeringNos.substr(0,offeringNos.length-1)
        return conflictOfferingNos
      }
      return
    },
    // 重置查询条件
    resetQuery () {
      this.dataForm = {
          statusList: [],
          deploymentReasonList: [],
          deploymentNo: '',
          originalPlace: '',
          destinationPlace: '',
          applicantName: '',
          noticeTime: '',
          noticeTime1: '',
          noticeTime2: '',
          vehicleNo: '',
          transportDateS: '',
          transportDateS1: this.startDay1,
          transportDateS2: this.startDay2,
          transportDateE: '',
          transportDateE1: '',
          transportDateE2: ''
      }
      this.queryCourse()
    },
    getSelectList (args) {
      if (args && args !== '' && args.length > 0) {
        let tramClass = []
        args.forEach(function (item) {
          tramClass.push(item.id)
        })
        this.dataForm.teamClassList = tramClass
      } else {
        this.dataForm.teamClassList = ''
      }
    },
    getVehicleList (args) {
      if (args && args !== '' && args.length > 0) {
        let vehicleArr = []
        args.forEach(function (item) {
          vehicleArr.push(item.id)
        })
        this.dataForm.vehicleClassList = vehicleArr
      } else {
        this.dataForm.vehicleClassList = ''
      }
    },
    editPriority (row) {
      let url = ''
      let param = ''
      url = `/rm/coursevehiclerela/update`
      param = {
        'id': row.id,
        'courseId': this.courseId,
        'vehicleId': this.vehicleId,
        'station': this.station,
        'priority': row.priority
      }
      this.$request.post(
        url,
        param
      ).then((data) => {
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500
        })
        this.getDataList()
      })
    },
    queryCourse () {
      this.page = 1
      if (this.dataForm.courseStatusArr instanceof Array) {
        this.dataForm.courseStatus = this.dataForm.courseStatusArr.join(',')
      }
      console.info('this.dataForm查询条件--------------------->', this.dataForm)
      this.getDataList()
    },
    // 批量导出
    columnBtn () {
      this.$request.downloadRm('/rm/vehicleinfoDeployment/export', this.$t('vehicleAllocation.columnBtn'),
        {
          ...this.dataForm,
          page: this.page,
          limit: this.limit
        }
      )
    },
    // 通知
    notice(){
      let _this = this
      let selectList = this.$refs.vehicleAllocation.selection
      if (selectList.length <= 0) {
        this.$message.warning(this.$t('vehicleAllocation.selectData'))
        return false
      }
      if(selectList[0].isConflict === '10'){
        this.$message.warning(this.$t('vehicleAllocation.isConflict'))
        return false
      }
      if (selectList.length <= 0) {
        this.$message.warning(this.$t('vehicleAllocation.selectData'))
        return false
      }
      if(selectList[0].status === '40'){
          this.$message.warning(this.$t('vehicleAllocation.selectNotice'))
          return false
      }
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('vehicleAllocation.notice') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        _this.dataListLoading = true
        let url = ''
        // let param = ''
        url = '/rm/vehicleinfoDeployment/notice'
        // param = { 'idList': idList }
        _this.$request.post(
                url, selectList
        ).then((data) => {
          _this.$message({
            message: _this.$t('prompt.success'),
            type: 'success',
            duration: 500
          })
          _this.dataListLoading = false
          _this.getDataList()
        })
      }).catch(() => {
        _this.dataListLoading = false
      })
    },
    // 入库
    storage(){
      let _this = this
      let selectList = this.$refs.vehicleAllocation.selection
      if (selectList.length <= 0) {
        this.$message.warning(this.$t('vehicleAllocation.selectData'))
        return false
      }
        if(selectList[0].status !== '30'){
            this.$message.warning(this.$t('vehicleAllocation.selectStorage'))
            return false
        }
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('vehicleAllocation.warehousing') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        _this.dataListLoading = true
        let url = ''
        // let param = ''
        url = '/rm/vehicleinfoDeployment/storage'
        _this.$request.post(
                url, selectList
        ).then((res, total, code, data) => {
          if(data.msg==='error'){
            this.$confirm(data.data, this.$t('prompt.title'), {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
            }).then(()=>{
              _this.dataListLoading = false
            })
          }
          else if (data.msg==='success'){
          _this.$message({
            message: _this.$t('prompt.success'),
            type: 'success',
            duration: 500
          })
          _this.dataListLoading = false
          _this.getDataList()
          }
        })
      }).catch(() => {
        _this.dataListLoading = false
      })
    },
    // 撤销
    revoke(row){
      let _this = this
      console.info(row)
      _this.$confirm(this.$t('prompt.info', { 'handle': this.$t('vehicleAllocation.delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        _this.dataListLoading = true
        let url = '/rm/vehicleinfoDeployment/delete'
        _this.$request.post(
                url, row
        ).then((data) => {
          _this.$message({
            message: _this.$t('prompt.success'),
            type: 'success',
            duration: 500
          })
          _this.dataListLoading = false
          _this.getDataList()
        }).catch(() => {
          _this.dataListLoading = false
        })
      }).catch(() => {
        _this.dataListLoading = false
      })
    },
    recall(row){
      let _this = this
      console.info(row)
      _this.$confirm(this.$t('prompt.info', { 'handle': this.$t('vehicleAllocation.recall') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        _this.dataListLoading = true
        let url = '/rm/vehicleinfoDeployment/updateStatus'
        row.status = '20'
        _this.$request.post(
                url, row
        ).then((data) => {
          _this.$message({
            message: _this.$t('prompt.success'),
            type: 'success',
            duration: 500
          })
          _this.dataListLoading = false
          _this.getDataList()
        }).catch(() => {
          _this.dataListLoading = false
        })
      }).catch(() => {
        _this.dataListLoading = false
      })
    },
    // 批量删除
    batchRevoke () {
      let _this = this
      let selectList = this.$refs.vehicleAllocation.selection
      let selectArr = []
      if (selectList.length <= 0) {
        this.$message.warning(this.$t('prompt.deleteBatch'))
        return false
      }
      for (var i in selectList) {
        if(selectList[i].status !=='20'){
          this.$message.warning('勾选的数据中有部分不是“已提交”状态的调配单（只有“已提交”状态的单据才能删除）,请确认并重新勾选')
          return false
        }
      }
      this.$confirm('确定进行批量删除操作？', this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        _this.dataListLoading = true
        let url = '/rm/vehicleinfoDeployment/batchDelete'
        let param = {
          'batchDeleteList': selectList
        }
        _this.$request.post(
          url, param
        ).then((data) => {
          _this.$message({
            message: _this.$t('prompt.success'),
            type: 'success',
            duration: 500
          })
          _this.dataListLoading = false
          _this.getDataList()
        })
      }).catch(() => {
        _this.dataListLoading = false
      })
    },
    // 归还申请
    returnAdd(row){
      console.info('row传到页面的值-------------------->', row)
      let name = 'rm-vehicleAllocation-return-add'
      let query = {}
      query.id = row.id
      this.$router.push({
        name: name,
        query: query
      })
      // 广播通知执行初始化方法
      this.$eventHub.$emit(this.GLOBAL.COURSE_VEHICALERELA, '')
    },
    checkVehicleNo(row){
      let _this = this
      this.vehicleInfoList = []
      let url = ''
      let param = ''
        url = '/rm/vehicleinfoDeployment/find'
      param = {
        ...row,
      }
      _this.$request.post(
              url, param
      ).then((data) => {
        console.info('data查看出来的值------------------->', data)
        this.vehicleInfoList.push(data.vehicleInfoVo)
      })
      _this.isShowVehicle = true
    },
    showVehicleClose(){
      this.isShowVehicle = false
    },
    checkDeploymentReason(row){
      let _this = this
      this.courseList = []
      let url = ''
      let param = ''
      url = '/rm/vehicleinfoDeployment/find'
      param = {
        ...row,
      }
      _this.$request.post(
              url, param
      ).then((data) => {
        console.info('data查看出来的值------------------->', data)
        this.courseList = data.vehicleDeploymentOVoList
      })
      _this.isShowDeploymentReason = true
    },
    showDeploymentReasonClose (){
      this.isShowDeploymentReason = false
    },
    // 车辆分类转换
    vehicleClassFormatter (row) {
      return Vue.filter('coverEnum')(row.vehicleClassification, 'vehicleClass')
    },
    getList (opt) {
      console.log(opt)
    },
    dataUpdate(){
      this.dataForm.noticeTime2 = this.dataForm.noticeTime2 + ' 23:59:59'
      console.info('this.dataForm.noticeTime2修改时间------------------------>', this.dataForm.noticeTime2)
    },
    // 时间格式化
    dateFormat(fmt, date) {
      let ret;
      const opt = {
          "Y+": date.getFullYear().toString(),        // 年
          "m+": (date.getMonth() + 1).toString(),     // 月
          "d+": date.getDate().toString(),            // 日
          "H+": date.getHours().toString(),           // 时
          "M+": date.getMinutes().toString(),         // 分
          "S+": date.getSeconds().toString()          // 秒
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
              fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
          };
      };
      return fmt;
  }
  }
}
</script>

<style scoped>
.postion {
  color: blue;
}
.postion:hover {
  outline: none;
  border-bottom: 1px solid blue;
}
.link-type,
.link-type:focus {
  color: #337ab7;
  cursor: pointer;
}
.link-type:hover {
  color: rgb(32, 160, 255);
}
</style>
<style lang="css" scoped>
  @import "../../css/pkg-styles.css";
</style>
<style>
  .trainer-search-condition .el-form-item__content {
    margin-left: 110px !important;
  }
</style>
<style>
  .el-table .warning-row {
    color: #FECB00;
  }
  .el-table .success-row {
    color: blue;
  }
</style>
